<template>
    <action>
        <template slot="header">Buchungszeitfenster</template>

        <template slot="action">
            <button-primary @click="showModal = true"><i class="fa fa-plus"></i> Neues Zeitfenster</button-primary>
        </template>

        <loading v-show="loading"></loading>

        <div v-show="slots.length > 0">
            <tailwind-table>
                <tr v-for="(s, i) in slots" :key="s.id">
                    <td class="px-3 py-3">{{ s.name }}</td>
                    <td class="px-3 py-3">{{ s.begin }} - {{ s.end }}h</td>
                    <td class="px-3 py-3 text-right">
                        <slot-edit v-model="slots[i]" @reload="load"></slot-edit>
                    </td>
                </tr>
            </tailwind-table>
        </div>

        <portal to="modal" v-if="showModal">
            <modal @close="showModal = false">
                <template slot="header">Neue Zeitfenster</template>

                <input-text v-model="local.name">
                    Name
                </input-text>

                <input-text type="number"
                            v-model="local.begin"
                >
                    Startzeit
                    <template slot="helper">Werte zwischen 0 und 23 Uhr</template>
                </input-text>

                <input-text type="number"
                            v-model="local.end"
                >
                    Endzeit
                    <template slot="helper">Werte zwischen 1 und 24 Uhr</template>
                </input-text>

                <template slot="action">
                    <button-primary @click="store"><i class="fa fa-save"></i> Speichern</button-primary>
                </template>
            </modal>
        </portal>
    </action>
</template>

<script>
import Card from "./UI/Card";
import Loading from "./UI/Loading";
import Modal from "./Modal";
import ButtonSecondary from "./UI/ButtonSecondary";
import ButtonPrimary from "./UI/ButtonPrimary";
import TailwindTable from "./UI/TailwindTable";
import SlotEdit from "./SlotEdit";
import InputText from "./UI/InputText";
import FullCard from "./UI/FullCard";
import Action from "./UI/Action";

export default {
    name: "SlotSettings",
    components: {
        Action,
        FullCard, InputText, SlotEdit, TailwindTable, ButtonPrimary, ButtonSecondary, Modal, Loading, Card
    },

    data: () => ({
        loading: false,
        slots: [],
        showModal: false,
        local: {
            name: 'Vormittags Tag',
            begin: 0,
            end: 12,
        }
    }),

    inject: ['group'],

    created() {
        this.load();
    },

    methods: {
        load() {
            this.loading = true;
            this.slots = [];
            window.axios.get(`/admin/slots`).then(response => {
                this.loading = false;
                this.slots = response.data.data;
            }).catch(error => {
                this.loading = false;
                this.$root.$emit('error', error);
            })
        },

        store() {
            this.loading = true;
            window.axios.post(`/admin/slots`, {
                begin: this.local.begin,
                end: this.local.end,
                name: this.local.name,
            }).then(response => {
                this.loading = false;
                this.showModal = false;
                this.load();
            }).catch(error => {
                this.loading = false;
                this.$root.$emit('error', error);
            })
        }
    }
}
</script>

<style scoped>

</style>